import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';
import Tooltip from 'ggApp/shared/containers/tooltip';
import { calculateVoucherPreviewDiscount } from 'ggApp/utils/experiments';

import {
    VoucherPreviewWrapper,
    VoucherIconAndText,
    DiscountIcon,
    VoucherText,
    VoucherAmount,
} from './styles';

const validateVoucherPreviewData = (
    cart: { itemTotal?: number },
    activeStore: { default_currency?: string; activeLanguage?: string },
    previewVoucher: { code?: string; description?: string; discount?: { type?: string } },
): boolean => {
    return Boolean(
        cart &&
            cart.itemTotal &&
            activeStore &&
            activeStore.default_currency &&
            activeStore.activeLanguage &&
            previewVoucher &&
            previewVoucher.code &&
            previewVoucher.description &&
            previewVoucher.discount &&
            previewVoucher.discount.type,
    );
};

export const VoucherPreview = (): JSX.Element | null => {
    const { cart, activeStore, previewVoucher } = useContext(OrderContext);
    const theme = useContext(ThemeContext);
    const voucherPreviewData = validateVoucherPreviewData(cart, activeStore, previewVoucher);

    if (!voucherPreviewData) {
        return null;
    }

    const formattedPreviewVoucherDiscount = calculateVoucherPreviewDiscount(
        previewVoucher,
        cart,
        activeStore,
    );
    return (
        <VoucherPreviewWrapper data-testid="voucher-preview">
            <VoucherIconAndText>
                <DiscountIcon size="20" color={theme.colors.Color2} />
                <Tooltip translatedText={previewVoucher.description}>
                    <VoucherText>{previewVoucher.code}</VoucherText>
                </Tooltip>
            </VoucherIconAndText>

            <VoucherAmount>{formattedPreviewVoucherDiscount}</VoucherAmount>
        </VoucherPreviewWrapper>
    );
};
